/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ProdevisImportLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Journal des imports Prodevis
     * Chaque devis recu de Prodevis par e-mail, toutes entreprises confondues ou filtre par `customer_id` et `status` (`processing`, `success`, `failed`, `dry_run`). 25 par page. Chaque entree : entreprise, numero de devis, statut, expediteur, nombre de pieces jointes et de fichiers importes, identifiants crees dans Lola, message d'erreur, dates.
     * @param customerId
     * @param status
     * @returns string
     * @throws ApiError
     */
    public prodevisImportLogIndex(
        customerId?: number | null,
        status?: 'processing' | 'success' | 'failed' | 'dry_run',
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/prodevis-imports',
            query: {
                'customer_id': customerId,
                'status': status,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un import Prodevis
     * Memes champs qu'une entree de la liste, pour un import donne.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public prodevisImportLogShow(
        id: number,
    ): CancelablePromise<{
        id: string;
        company_key: string;
        company_name: string;
        customer_id: string;
        quote_number: string;
        status: string;
        email_from: string;
        attachments_count: string;
        files_uploaded: string;
        lola_devis_id: string;
        lola_projet_id: string;
        lola_client_id: string;
        error_message: string;
        created_at: string;
        completed_at: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/prodevis-imports/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Relancer un import Prodevis en echec
     * Uniquement pour un import `failed` (422 sinon). Verifie que le devis existe encore dans la base Prodevis de l'entreprise (404 sinon, 503 si la base est injoignable), puis relance l'import en tache de fond — **sans les pieces jointes de l'e-mail d'origine**, qui ne sont plus disponibles. Reponse : `{ message, log_id }`.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public prodevisImportLogRetry(
        id: number,
    ): CancelablePromise<{
        success: boolean;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/prodevis-imports/{id}/retry',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
